import { sha256 } from 'js-sha256';
import { isEmpty } from 'lodash';
// uses this hash library: https://www.npmjs.com/package/js-sha256
function createHash(str) {
    const msgUint8 = new TextEncoder().encode(str); // encode as (utf-8) Uint8Array
    const hashBuffer = sha256.digest(msgUint8); // hash the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
    const minimalHash = parseInt(hashHex.substring(0, 6), 16); // take first 6 characters of hex string and convert to decimal
    const finalHash = minimalHash / 0xffffff; // divide by max value of 6 character hex string to get a value between 0 and 1
    return finalHash;
}
function validateExperimentData(experiment) {
    if (isEmpty(experiment.name)) {
        throw new Error('Experiment name cannot be empty');
    }
    if (experiment.variations.length === 0) {
        throw new Error('Experiment must have at least one variation');
    }
    if (isEmpty(normalizeIdentifier(experiment.identifier))) {
        throw new Error('Experiment identifier cannot be empty');
    }
}
function normalizeIdentifier(identifier) {
    return String(typeof identifier === 'function' ? identifier() : identifier);
}
export function getExperimentVariation(experiment) {
    validateExperimentData(experiment);
    let splitsSum = experiment.variations.reduce((acc, variation) => {
        return acc + variation.split;
    }, 0);
    let identifier = normalizeIdentifier(experiment.identifier);
    let value = (experiment.forceValue ?? createHash(experiment.name + identifier)) * splitsSum;
    let currentValue = 0;
    for (let variation of experiment.variations) {
        currentValue += variation.split;
        if (value <= currentValue) {
            return variation.id;
        }
    }
    // Fall back to the first variation just in case, but this should never happen
    return experiment.variations[0]?.id ?? '';
}
//# sourceMappingURL=index.js.map